import { render, staticRenderFns } from "./user-service.vue?vue&type=template&id=2fd45034&scoped=true&"
import script from "./user-service.vue?vue&type=script&lang=js&"
export * from "./user-service.vue?vue&type=script&lang=js&"
import style0 from "./user-service.vue?vue&type=style&index=0&id=2fd45034&prod&lang=scss&"
import style1 from "./user-service.vue?vue&type=style&index=1&id=2fd45034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd45034",
  null
  
)

export default component.exports